// extracted by mini-css-extract-plugin
export default {"coffee":"statistic_coffee__L9MYF","demo":"statistic_demo__HKMrU","card":"statistic_card__tHXnc","container":"statistic_container__L9tGF"};